import React from 'react';
import styles from '../css/ErrorModal.module.css';
import { getNotes } from '../../../actions/noteActions';
import { useDispatch } from 'react-redux';
import { AiOutlineArrowLeft, AiOutlineReload } from 'react-icons/ai';
import { FiX } from 'react-icons/fi';

const NotFound = ({msg,closeMenu}) => {
    const dispatch = useDispatch()

    const handleRefresh = () => {
        dispatch(getNotes())
        closeMenu()
    }

    return (
        <div data-testid = "not-found-box" className = {styles.wrapper}>
            <div className={styles.popup}>
                <button type = "button" className={styles.close} onClick = {()=>closeMenu()}>
                    <FiX/>
                </button>
                <div className={styles.inner}>
                    <div className={styles.illus}>
                        <img
                            src = "/assets/404Error.png"
                            alt="404 ERROR"
                            loading="lazy"
                        />
                    </div>
                    <div className={styles.text}>
                        <div className={styles.eyebrow}>Error 404</div>
                        <div className={styles.title}>
                            Oops, note<br />
                            <em>not found.</em>
                        </div>
                        <div className={styles.desc}>
                            {msg}
                        </div>
                        <div>
                            <button type = "button" className={styles.refreshBtn} onClick = {()=>handleRefresh()}>
                                Refresh Page
                                <div className={styles.btnIcon}><AiOutlineReload/></div>
                            </button>
                            <br />
                            <button type = "button" className={styles.backBtn} onClick = {()=>closeMenu()}>
                                <AiOutlineArrowLeft/> Back to My Notes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound